import React from "react";
import { Box, type BoxProps } from "@chakra-ui/react";
import { Container, horizontalContainerPadding } from "ui/container";
import { type Theme, type ThemeBgColor } from "contexts/color-theme";
import { useColorThemeToggle } from "../hooks/use-color-theme-toggle";

export const sectionSpacingY = { base: "sectionSpacingY.base", md: "sectionSpacingY.md" };

export type SectionProps = {
  center?: boolean; // eslint-disable-line react/boolean-prop-naming
  fullWidth?: boolean; // eslint-disable-line react/boolean-prop-naming
  noContainerPx?: boolean; // eslint-disable-line react/boolean-prop-naming
  theme?: Theme;
  themeBgColor?: ThemeBgColor;
} & BoxProps;

export function Section({
  children,
  center,
  fullWidth,
  noContainerPx,
  bg,
  theme = "light",
  themeBgColor = "white",
  ...props
}: SectionProps) {
  const scope = useColorThemeToggle({ theme, bgColor: themeBgColor });

  return (
    <Box ref={scope} as="section" bg={bg} py={bg ? sectionSpacingY : 0} my={bg ? 0 : sectionSpacingY} {...props}>
      <Container fullWidth={fullWidth} center={center} px={noContainerPx ? 0 : horizontalContainerPadding}>
        {children}
      </Container>
    </Box>
  );
}
